/*global Modernizr, dd_map_locations, dd_generated_locations, double_dave_map_styles, alert, console */
/*jslint browser:true */

(function() {
  'use strict';

  var location_search_form = document.querySelector('.page-hero .dd-form.location-search-form:not(.js-location-search-form)'),
      location_search_status = document.getElementById('locations-search-status'),
      location_search_error = document.getElementById('locations-search-error'),
      location_search_loading = document.getElementById('locations-search-loading'),
      location_search_no_results = document.getElementById('locations-search-no-results'),
      location_view_toggle_container = document.querySelector('.location-search-hero .location-views'),
      locations_search_list_container = document.getElementById('locations-search-list'),
      locations_search_map_container = document.getElementById('locations-search-map'),
      saved_bounds = false,
      open_marker = false,
      map = null,
      infobox = null;

  if(location_search_form) {
    var search_zipcode = location_search_form.querySelector('input[name="zip"]'),
        search_city = location_search_form.querySelector('select[name="city"]');

    location_view_toggle_container.addEventListener('click', (e) => {
      e.preventDefault();

      if(e.target.tagName.toLowerCase() === 'button') {
        let new_view = e.target,
            new_view_type = new_view.getAttribute('data-view'),
            previous_view = location_view_toggle_container.querySelector('.active');

        previous_view.classList.remove('active');
        document.getElementById('locations-search-' + previous_view.getAttribute('data-view')).classList.add('hidden');

        new_view.classList.add('active');
        document.getElementById('locations-search-' + new_view_type).classList.remove('hidden');

        window.history.replaceState('', '', document.location.pathname + '?view=' + new_view_type);

        if(new_view_type === 'map' && saved_bounds !== false) {
          map.fitBounds(saved_bounds);
          saved_bounds = false;
        }

        location_search_status.innerText = 'View switched to ' + new_view_type;
      }
    });

    location_search_form.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if(search_zipcode.value !== '' && search_zipcode.value.length === 5) {
        search_city.value = '';

        start_search();
        search_ajax_zipcode();
      }

      return false;
    });

    search_city.addEventListener('change', (e) => {
      search_zipcode.value = '';

      start_search();
      search_ajax_city();
    });

    locations_search_list_container.addEventListener('load-locations', (e) => {
      const locations_row = locations_search_list_container.querySelector('.location-grid.row');

      locations_row.innerHTML = '';

      e.detail.locations.forEach((location) => {
        var location_node = dd_build_location_info(location);

        locations_row.appendChild(location_node);
      });
    });

    locations_search_map_container.addEventListener('load-locations', (e) => {
      let bounds = new google.maps.LatLngBounds();

      e.detail.locations.forEach((location) => {
        if(location.latitude !== '' && location.longitude !== '') {
          const location_position = new google.maps.LatLng(location.latitude, location.longitude);

          if(!e.detail.is_geo || (location.distance != null && location.distance <= 30)) {
            bounds.extend(location_position);
          }
        }
      });

      if(bounds.isEmpty()) {
        e.detail.locations.forEach((location) => {
          if(location.latitude !== '' && location.longitude !== '') {
            const location_position = new google.maps.LatLng(location.latitude, location.longitude);
            bounds.extend(location_position);
          }
        });
      }

      if(!locations_search_map_container.classList.contains('hidden')) {
        map.fitBounds(bounds, 0);
      } else {
        saved_bounds = bounds;
      }
    });
  }

  document.body.addEventListener('dd-map', (e) => {
    var SVGMarker = get_dd_marker(),
        InfoBox = get_dd_infobox(),
        marker_position = new google.maps.LatLng(31.695456, -98.620484);

    if(!locations_search_map_container) {
      return;
    }

    map = new google.maps.Map(locations_search_map_container.querySelector('.map-container'), {
      zoom: 8,
      maxZoom: 17,
      center: marker_position,
      mapTypeControl: false,
      panControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      scaleControl: false,
      scrollwheel: false,
      styles: double_dave_map_styles
    });

    map.addListener('click', (e) => {
      close_open_infobox();
    });

    map.addListener('zoom_changed', (e) => {
      close_open_infobox();
    });

    let bounds = new google.maps.LatLngBounds();

    let infobox_width = dd_get_infobox_width();

    infobox = new InfoBox({
      content: '',
      pixelOffset: new google.maps.Size(((infobox_width / 2) * -1), -65),
      alignBottom: true,
      position: new google.maps.LatLng(30.265474, -97.746557),
      boxStyle: {
        width: infobox_width + 'px'
      },
      closeBoxURL: '',
      infoBoxClearance: new google.maps.Size(10, 10)
    });

    window.addEventListener('resize', () => {
      let infobox_width = dd_get_infobox_width();

      infobox.setOptions({
        pixelOffset: new google.maps.Size(((infobox_width / 2) * -1), -65),
        boxStyle: {
          width: infobox_width + 'px'
        }
      });
    });

    dd_map_locations.forEach((location) => {
      if(location.latitude !== '' && location.longitude !== '') {
        let location_position = new google.maps.LatLng(location.latitude, location.longitude);

        var marker_html = `<div class="marker-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve">
            <path class="marker-border" style="fill:#FFFFFF;" d="M48.4,8.5c-0.8-0.8-1.6-1.6-2.3-2.3C36.3-2.7,21.2-2,12.2,7.8C3.3,17.6,4,32.7,13.8,41.6 c0.2,0.2,0.5,0.5,0.8,0.7c5.6,4.6,10.3,10.3,13.8,16.7c0.3,0.6,1,1,1.8,1c0.7,0,1.4-0.4,1.8-1l0.2-0.3c3.5-6.3,8.2-11.9,13.7-16.5 C55.9,33.6,57,18.5,48.4,8.5z"/>
            <path class="marker-background" style="fill:#312e2c;" d="M46,10.4c-0.6-0.7-1.2-1.3-1.9-1.9C40,4.8,35,3,29.9,3c-5.7,0-11.4,2.3-15.5,6.8 c-7.8,8.5-7.2,21.8,1.4,29.6c0.2,0.2,0.4,0.4,0.7,0.6c5.4,4.5,10,9.9,13.6,16c3.6-6.2,8.3-11.6,13.8-16.1c4.2-3.6,6.7-8.7,7.1-14.3 C51.4,20,49.6,14.6,46,10.4z M30.1,34.1c-5.5,0-10-4.5-10-10s4.5-10,10-10s10,4.5,10,10S35.6,34.1,30.1,34.1z"/>
            </svg></div>`;

        let marker = new SVGMarker({
          map: map,
          position: location_position,
          clickable: true,
          icon: {
            size: new google.maps.Size(60, 60),
            anchor: new google.maps.Point(30, 60),
            class: 'SVGMarker',
            html: marker_html
          },
          infobox: dd_build_location_info(location)
        });

        marker.addListener('click', (e) => {
          e.stopPropagation();
          e.preventDefault();
          e.cancelBubble = true;

          var marker_is_open = marker.container.classList.contains('open');

          close_open_infobox();

          if(!marker_is_open) {
            marker.container.classList.add('open');

            infobox.setContent(marker.infobox);
            infobox.setPosition(marker.getPosition());
            infobox.open(map);
            open_marker = marker;
          }
        });

        if(dd_generated_locations.includes(location.id)) {
          bounds.extend(location_position);
        }
      }
    });

    if(!bounds.isEmpty()) {
      if(!locations_search_map_container.classList.contains('hidden')) {
        map.fitBounds(bounds, 0);
      } else {
        saved_bounds = bounds;
      }
    }
  });

  document.body.addEventListener('load-geolocation', (e) => {
    var search_zipcode = location_search_form.querySelector('#location-search-field-zip'),
        search_city = location_search_form.querySelector('#location-search-input-city');

    search_zipcode.value = '';
    search_city.value = '';

    if(document.body.classList.contains('modal-open')) {
      document.getElementById('modal-location-search').querySelector('.modal-close').click();
    }

    location_search_status.innerText = 'Searching locations.';

    wp.ajax.post({'action': 'location_search', 'geolocation': '1'})
      .done(function(response) {
        process_locations(response);
      })
      .fail(function(response) {
        if('error' in response) {
          return throw_error(response.error);
        }

        return throw_error('Error loading locations.');
      });
  });

  function start_search() {
    var search_zipcode = location_search_form.querySelector('#location-search-field-zip'),
        search_city = location_search_form.querySelector('#location-search-input-city'),
        view_buttons = location_view_toggle_container.querySelectorAll('button');

    search_zipcode.disabled = true;
    search_city.disabled = true;
    location_search_form.querySelector('button[type="submit"]').disabled = true;
    location_search_form.querySelector('button.location-search-geolocation').disabled = true;

    view_buttons.forEach((view_button) => {
      view_button.disabled = true;
    });

    locations_search_list_container.classList.add('hidden');
    locations_search_map_container.classList.add('hidden');

    location_search_error.classList.add('hidden');
    location_search_loading.classList.remove('hidden');
    location_search_no_results.classList.add('hidden');
  }

  function end_search(enable_view_toggle = true) {
    var search_zipcode = location_search_form.querySelector('#location-search-field-zip'),
        search_city = location_search_form.querySelector('#location-search-input-city'),
        view_buttons = location_view_toggle_container.querySelectorAll('button');

    search_zipcode.disabled = false;
    search_city.disabled = false;
    location_search_form.querySelector('button[type="submit"]').disabled = false;
    location_search_form.querySelector('button.location-search-geolocation').disabled = false;

    location_search_error.classList.add('hidden');
    location_search_loading.classList.add('hidden');

    if(enable_view_toggle) {
      view_buttons.forEach((view_button) => {
        view_button.disabled = false;
      });

      document.getElementById('locations-search-' + location_view_toggle_container.querySelector('.active').getAttribute('data-view')).classList.remove('hidden');
    }
  }

  function search_ajax_zipcode() {
    var search_zipcode = location_search_form.querySelector('#location-search-field-zip');

    location_search_status.innerText = 'Searching locations.';

    wp.ajax.post({'action': 'location_search', 'zipcode': search_zipcode.value})
      .done(function(response) {
        process_locations(response);
      })
      .fail(function(response) {
        if('error' in response) {
          return throw_error(response.error);
        }

        return throw_error('Error loading locations.');
      });
  }

  function search_ajax_city() {
    var search_city = location_search_form.querySelector('#location-search-input-city');
    location_search_status.innerText = 'Searching locations.';

    var city = search_city.options[search_city.selectedIndex],
        state = city.parentNode,
        data = {'action': 'location_search'};

    if(search_city.selectedIndex !== 0) {
      data = {'action': 'location_search', 'state': state.getAttribute('data-slug'), 'city': city.value};
    }

    wp.ajax.post(data)
      .done(function(response) {
        process_locations(response);
      })
      .fail(function(response) {
        if('error' in response) {
          return throw_error(response.error);
        }

        return throw_error('Error loading locations.');
      });
  }

  function process_locations(response) {
    const locations = response.locations;
    const page_title = response.title;

    let title = document.querySelector('title');
    let title_content = title.innerText.split(' | ');
    title_content[0] = page_title;
    title.innerText = title_content.join(' | ');

    document.querySelector('h1').innerText = page_title;

    window.history.replaceState('', '', response.url);

    if(locations.length === 0) {
      end_search(false);
      location_search_no_results.classList.remove('hidden');
      return;
    }

    end_search();

    const event = new CustomEvent('load-locations', {
      detail: {
        is_geo: response.is_geo,
        locations: locations
      }
    });
    locations_search_list_container.dispatchEvent(event);
    locations_search_map_container.dispatchEvent(event);

    location_search_status.innerText = locations.length + ' results returned.';
  }

  function throw_error(error) {
    var search_zipcode = location_search_form.querySelector('#location-search-field-zip'),
        search_city = location_search_form.querySelector('#location-search-input-city'),
        view_buttons = location_view_toggle_container.querySelectorAll('button');

    search_zipcode.disabled = false;
    search_city.disabled = false;
    location_search_form.querySelector('button[type="submit"]').disabled = false;
    location_search_form.querySelector('button.location-search-geolocation').disabled = false;

    location_search_error.innerText = error;

    view_buttons.forEach((view_button) => {
      view_button.disabled = true;
    });

    locations_search_list_container.classList.add('hidden');
    locations_search_map_container.classList.add('hidden');

    location_search_loading.classList.add('hidden');
    location_search_error.classList.remove('hidden');
  }

  function stringToHtml(string) {
    const placeholder = document.createElement("div");
    placeholder.innerHTML = string;
    return placeholder.firstElementChild;
  }

  function dd_build_location_info(location, convert = true) {
    var location_dom = `<div class="card location-card${location.coming_soon ? ` coming-soon`:``}"${location.store_hours !== '' ? ` data-distance="${location.distance}"` : ''}>
  ${location.coming_soon ? `
  <div class="location-coming-soon">
    Coming Soon
    <svg version="1.1" class="cap-left" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 50" style="enable-background:new 0 0 30 50;" xml:space="preserve">
      <path style="fill:#FC8A45;stroke:#FFFFFF;stroke-width:3;" d="M 5 1.5 H 2.6 l 1 2.1 l 10 21.4 l -10 21.4 l -1 2.1 H 5 h 15 L 20 1.5 z"/>
    </svg>
    <svg version="1.1" class="cap-right" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 50" style="enable-background:new 0 0 30 50;" xml:space="preserve">
      <path style="fill:#FC8A45;stroke:#FFFFFF;stroke-width:3;" d="M 5 1.5 H 2.6 l 1 2.1 l 10 21.4 l -10 21.4 l -1 2.1 H 5 h 15 L 20 1.5 z"/>
    </svg>
  </div>`:``}

  <h2>${location.title}</h2>

  ${dd_line}

  <div class="location-info">
    <div class="grid-cell">
      <p>${location.address}</p>

      ${location.phone_number}
    </div>

    <div class="location-hours grid-cell">
      ${location.store_hours !== '' ? `<div class="grid-cell"><strong>Dough Slingin\' Hours:</strong> ${location.store_hours}</div>` : ``}
      ${location.buffet_hours !== '' ? `<div class="grid-cell"><strong>Buffet Hours:</strong> ${location.buffet_hours}</div>` : ``}
    </div>
  </div>

  ${dd_line}

  ${location.features !== '' ? `<div class="location-features">${location.features}</div>` : ``}

  <div class="button-grid">
    ${location.link_order_now}
    ${location.link_permalink}
    ${location.link_directions}
  </div>
</div>`;

    if(convert) {
      return stringToHtml(location_dom);
    }

    return location_dom;
  }

  function close_open_infobox() {
    if(infobox.getVisible()) {
      if(open_marker) {
        open_marker.container.classList.remove('open');
        open_marker = false;
      }

      infobox.close();
    }
  }

  function dd_get_infobox_width() {
    let infobox_width = 640;

    if(locations_search_map_container.offsetWidth <= 680) {
      infobox_width = 420;
    }

    if(locations_search_map_container.offsetWidth <= 460) {
      infobox_width = 320;
    }

    return infobox_width;
  }
}());